<nav class="navbar box-shadow app-header" [class.fixed-top]="settings.theme.navbarIsFixed"
  [class.logo-visible]="showInfoContent">
  <div class="d-flex flex-column w-100">
    <div id="info-content" class="panel-collapse collapse">
      <a class="close" data-toggle="collapse" href="#info-content" (click)="showInfoContent = !showInfoContent"
        [class.show]="showInfoContent">
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div class="d-flex justify-content-start align-items-center top-navbar">   
      <span class="navbar-text menu-icon transition  mr-1 mt-2">
        <i class="fa fa-outdent " (click)="settings.theme.showMenu = !settings.theme.showMenu"
          style="font-size:20px;color:black;margin-left: -5px"></i>
      </span>
      <a class="logo">
        <span style="color:#00786a;font-weight: bold;font-size: 20px;">Consultation</span>&nbsp;<span
          style="color:black;font-size: 20px;font-weight: bold;">Service</span>
      </a>
      <!-- Agency -->
      <div class="app-search d-none d-md-inline-block ms-5 col-lg-3  col-sm-4 col-md-3">
        <label *ngIf="global.agencyCode == 'SUPERADMIN' ">Agency</label>
        <ng-select *ngIf="global.agencyCode == 'SUPERADMIN' " class="col-10 mt-1" [ngModelOptions]="{standalone: true}"
          [(ngModel)]="global.selectedAgencyDropdown" (change)="refreshAgencyPage()" style=" color: black;"
          [clearable]="true" [searchable]="true" [items]="global.globalAgencyDropDown" bindLabel="Value"
          bindValue="Key">
        </ng-select>
      </div>
      <form class="d-none d-md-inline-block ml-3 mt-4" *ngIf="global.isServiceWorkersEnabled">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center">
              <h3 class="animate-charcter" (click)="activateToCurrentVersion()" title="Click to Refresh">New Version
                Available</h3>
            </div>
          </div>
        </div>
      </form>
      <!-- Location -->
      <div class="app-search d-none d-md-inline-block ms-5 col-lg-3  col-sm-4 col-md-3"
        *ngIf="this.global.OnboardingLoginType!='onboardLogin'">
        <label *ngIf="global.selectedLocationDropdown!=null && global.selectedLocationDropdown!=undefined &&
                global.selectedLocationDropdown!=''" style="color: black;"> {{global.LocationName}}</label>
        <label *ngIf="global.selectedLocationDropdown==null || global.selectedLocationDropdown==undefined ||
                global.selectedLocationDropdown==''">Location</label>
        <ng-select class="col-10 mt-1" [ngModelOptions]="{standalone: true}"
          [(ngModel)]="global.selectedLocationDropdown" (change)="refreshLocationPage(global.selectedLocationDropdown)"
          style=" color: black;" [clearable]="true" [searchable]="true" [items]="global.globalLocationList"
          bindLabel="Value" bindValue="Key">
        </ng-select>
      </div>
      <label id="agencyName" *ngIf="this.global.agencyCode!='SUPERADMIN'">{{global.agencyName}}</label>
      
      <div class="top-rigth-icons ms-auto"> 
      
      </div>

      <!-- <span  *ngIf="global.isWidgetLoaded && global.agencyCode!='SUPERADMIN' && global.OnboardingLoginType == 'agencyLogin' && env.isWidget && global.ccxWidget"  class="ml-4 ms-auto " style="margin-right: 9px; margin-top: 14px;width:34px" (click)="triggerReset()"> -->
        <!-- <button  class="circle-button"
        data-bs-toggle="tooltip" 
  data-bs-placement="top" 
  [attr.title]="global.isWidgetLoaded ? 'CCX Widget' : 'Widget is not loaded'"
  
        >
          <svg style="fill: white; width: 13px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            
            
           
            
            <path d="M256 48C141.1 48 48 141.1 48 256l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40C0 114.6 114.6 0 256 0S512 114.6 512 256l0 144.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24l-32 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l32 0c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40L464 256c0-114.9-93.1-208-208-208zM144 208l16 0c17.7 0 32 14.3 32 32l0 112c0 17.7-14.3 32-32 32l-16 0c-35.3 0-64-28.7-64-64l0-48c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64l0 48c0 35.3-28.7 64-64 64l-16 0c-17.7 0-32-14.3-32-32l0-112c0-17.7 14.3-32 32-32l16 0z"/></svg>
        </button> -->
      <!-- </span>  -->

      <!-- <span  *ngIf=" global.agencyCode!='SUPERADMIN' && global.OnboardingLoginType == 'onboardLogin' && env.isWidget && global.ccxWidget"  class="ml-4 ms-auto " style="margin-right: 9px; margin-top: 14px;width:34px" (click)="settings.theme.showSideChat = !settings.theme.showSideChat">
        <button class="circle-button">
          <svg style="fill: white; width: 13px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            
            
          
            <path d="M256 48C141.1 48 48 141.1 48 256l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40C0 114.6 114.6 0 256 0S512 114.6 512 256l0 144.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24l-32 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l32 0c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40L464 256c0-114.9-93.1-208-208-208zM144 208l16 0c17.7 0 32 14.3 32 32l0 112c0 17.7-14.3 32-32 32l-16 0c-35.3 0-64-28.7-64-64l0-48c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64l0 48c0 35.3-28.7 64-64 64l-16 0c-17.7 0-32-14.3-32-32l0-112c0-17.7 14.3-32 32-32l16 0z"/></svg>
        </button>
      </span>  -->

      <!-- <div  *ngIf="   global.agencyCode!='SUPERADMIN' && global.OnboardingLoginType == 'agencyLogin' && env.isWidget && global.ccxWidget">
        <app-agent-widget class="ml-3" 
        ></app-agent-widget>  
      </div> -->
      <!-- <div  *ngIf=" global.agencyCode!='SUPERADMIN' && global.OnboardingLoginType == 'onboardLogin' && env.isWidget && global.ccxWidget">
        <app-customer-widget class="ml-3" 
        ></app-customer-widget>  
      </div> -->
      <app-user-menu class="ml-3 mt-4" style="margin-right: 12px;"></app-user-menu> 
        <app-fullscreen class="ml-3 mt-4" style="margin-right: 9px;"></app-fullscreen>
      
    </div>
    <div class="horizontal-menu-outer" *ngIf="settings.theme.menu == 'horizontal'">
      <app-horizontal-menu *ngIf="showHorizontalMenu" [menuItems]="menuItems"></app-horizontal-menu>
      <app-vertical-menu *ngIf="!showHorizontalMenu" [menuItems]="menuItems"></app-vertical-menu>
    </div>
  </div>
</nav>
<!-- ChangePassword for client & employee onboarding -->
<span id="openandcloseChangePasswordModal" data-bs-target="#ChangePassword" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="ChangePassword" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-md " role="document">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Change Password</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <form [formGroup]="PasswordForm">
          <div class="form-group">
            <label>Old password <sup style="color:red; font-size: 1.35em;
                top: 0em;">&nbsp;*</sup></label>
            <input class="form-control" type="password" autocomplete="off" formControlName="old_password"
              name="old_password" [(ngModel)]="oldpwd"
              [ngClass]="{ 'is-invalid ': (submittedPassword || validationPass.old_password.touched) &&  validationPass.old_password.errors }">
          </div>
          <div style="color:red;"
            *ngIf="(submittedPassword || validationPass.old_password.touched) && validationPass.old_password.errors"
            class="is-invalid  ">
            <div class="errormsg-topic is-invalid" style="color:red;"
              *ngIf="((submittedPassword || validationPass.old_password.touched) && validationPass.old_password.errors.required)==null?false:true">
              Incorrect Password
            </div>
          </div>
          <!-- ...................................................................................................... -->
          <div class="form-group">
            <label>New Password<sup style="color:red; font-size: 1.35em;
              top: 0em;">&nbsp;*</sup></label>
            <input class="form-control" autocomplete="false" type="password" formControlName="newPass" name="newPass"
              [(ngModel)]="newpwd" (keyup)="passvalid($event)">
          </div>
          <div style="color:red;"
            *ngIf="(!PasswordForm.controls['newPass'].valid &&( PasswordForm.controls['newPass'].touched || submittedPassword) )||(PasswordForm.controls['newPass'].errors?.required &&( submittedPassword || PasswordForm.controls['newPass'].touched) ) "
            class="errormsg-topic">
            <div style="color:red;"
              *ngIf="PasswordForm.controls['newPass'].errors?.required && ( submittedPassword || PasswordForm.controls['newPass'].touched)">
              Please enter new password</div>
            <div style="color:red;"
              *ngIf="(PasswordForm.controls['newPass'].errors?.minlength && (PasswordForm.controls['newPass'].touched || submittedPassword)) ">
              Please enter minimum 8 characters
            </div>
          </div>
          <!-- ...................................................................................................................... -->
          <div class="form-group">
            <label>Confirm Password <sup style="color:red; font-size: 1.35em;
              top: 0em;">&nbsp;*</sup></label>
            <input class="form-control" autocomplete="false" type="password" formControlName="confirmPass"
              [(ngModel)]="newpwd1" (keyup)="passvalid($event)" name="confirm_password">
          </div>
          <div style="color:red;"
            *ngIf="(submittedPassword ||submittedPassword || validationPass.confirmPass.touched) && validationPass.confirmPass.errors"
            class="is-invalid ">
            <div class="errormsg-topic is-invalid" style="color:red;"
              *ngIf="((submittedPassword || validationPass.confirmPass.touched) && validationPass.confirmPass.errors.required)==null?false:true">
              Please enter confirm password
            </div>
          </div>
          <!-- ................................................................................................................ -->
          <p style="color:red;" class="errormsg-topic is-invalid" *ngIf="passwordMatch==true">
            Password does not Match
          </p>
          <div class="row">
            <div class="col-lg-12">
              <label><i>Note:&nbsp;Password should contain atleast 8 characters/
                  digits includes 1 special character, 1 lower and uppercase characters
                </i></label>
            </div>
          </div>
        </form>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" [disabled]="!PasswordForm.valid ||passerror"
          (click)="UpdatePassword()">Change</button>
        <button type="button" class="btn btn-sm" (click)="clear_pass()" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>